import React, { useState, forwardRef, useImperativeHandle, useEffect, useRef } from 'react'
import StepperNavigationButtons from '../../../MyInvitations/Common/StepperNavigationButtons';
import Tabs from '../../../MyInvitations/Common/TitleCustomizations/Tab';
import Home from './SubSections/Home';
import About from './SubSections/About';
import Awards from './SubSections/Awards';
import Gallery from './SubSections/Gallery';
import Contact from './SubSections/Contact';
import Record from './Record';
import ImageBrowse from '../../../../Common/Image/ImageBrowse';



const HomePage2 = forwardRef(
  function HomePage2(props, ref) {
    const [titles, setTitles] = useState(props.Titles);
    const [currentTab, setCurrentTab] = useState(0);
    const [Datapass1, setDatapass1] = useState(0);
    const [Datapass2, setDatapass2] = useState(0);
    const [Datapass3, setDatapass3] = useState(0);
    const [Datapass4, setDatapass4] = useState(0);
    const [Datapass5, setDatapass5] = useState(0);
    const [title, setTitle] = useState("");
        const [imageKey, setImageKey] = useState(null);
        const imageRef = useRef();
        const [file3, setFile3] = useState(null);
      const [subTitle, setSubTitle] = useState("");
    const setTitleData = (data) => {
      let titlesData = [];
      data.forEach((item, index) => {
        titlesData.push({
          title: item.title,
          sectionTitle: item.sectionTitle,
          sectionSubTitle: item.sectionSubTitle,
          navbarTitle: item.navbarTitle,
          show: index == 0,
          isValid: false,
          ref: null
        })
      });
      setTitles(titlesData);
    }

    const validate = () => {
      let isValid = true;
      const currentTitles = [...titles];
      setTitles(currentTitles);
      return isValid;
    }

    const getData = () => {

     
      return {
        title: title,
        subTitle: subTitle,
        image: imageRef?.current?.getThumbnail() ?? null,
        imageFile: imageRef?.current?.getImageFile() ?? null,
        imageKey: imageKey,
        Records: Datapass3,
      }
    }
    const handleCroppedImage3 = (file) => {
      setFile3(file) 
   }
    useImperativeHandle(ref, () => ({
      getData: getData,
      validate: validate,

    }));


    const handleTabClick = (index) => {
      setCurrentTab(index);
    };
    const handleDataClick = (data) => {
      setDatapass1(data)
     
    };
    const handleDataClick2 = (data) => {
      setDatapass2(data)
    };
    const handleDataClick3 = (data) => {
      setDatapass3(data)

    };
    const handleDataClick4 = (data) => {
      setDatapass4(data)
    };
    const handleDataClick5 = (data) => {
      setDatapass5(data)
    };
    
    const renderTabContent = (title) => {
      switch (title.title) {

        case "Home Header":
          // return <Home Data={handleDataClick} />;
          return <Record  Data={handleDataClick3} />;
        // case "Home Slider":
        //   return <About Data={handleDataClick2} />;
        // case "Records":
        //   return <Record  Data={handleDataClick3} />;
        // case "Awards":
        //   return <Awards Data={handleDataClick4}/>;
        // case "Testimonials":
        //   return <Contact  Data={handleDataClick5}/>;
        default:
          return null;
      }
    };

    // console.log(titles)

    return (
      <div className="content d-block visible">
        <div className="content-header mb-3 d-flex justify-content-between">
          <div className="sec-titler">
            <h2 className="text-primary">Title Customizations</h2>
            <div className="title-shape"></div>
            <small className="fs-11 mb-0"></small>
          </div>
        </div>
        <form>
          <div className="row g-3">
          <div className="col-sm-6">
              <label className="form-label" htmlFor="section2Name">
             Event Heading Title
              </label>
              <input
                type="text"
                id="section2Name"
                name="section2Name"
                placeholder="Please enter the main title here"
                className={`form-control `}
                value={title}
                onChange={(e) => setTitle(e.target.value)}
              // style={{ height: "245px", resize: "none" }}
              />
             
            </div>


            <div className="col-sm-6">
              <label className="form-label" htmlFor="section1TagLine">
             Event Sub Heading Title
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="Please enter the sub heading title here"
                name="section1TagLine"
                id="section1TagLine"
                value={subTitle}
                onChange={(e) => setSubTitle(e.target.value)}
              />
            </div>
            <div className="col-sm-6">
            <div className="row ">
              <div >
                <label className="form-label" htmlFor="image">
                   Image <small className="text-gray">(Max Allowable File Size: 1MB,Image Dimensions: 750px x 750px)</small>
                </label>
                <ImageBrowse
                elementId="slide3Image" 
                   ref={imageRef} imageType="background"
                  imageKey={imageKey} 
                  setImageKey={setImageKey} 
                  onImageCropped={handleCroppedImage3}
                  imageDelete={props.imageDelete} />
              </div>
            </div>
            
            </div>
            <div className="mt-3">
            <Record  Data={handleDataClick3} />;
              {/* <Tabs tabs={titles} currentTab={currentTab} onTabClick={handleTabClick} /> */}
              {/* <div className="tab-content">
                {titles.map((title, index) => (
                  <div
                    key={index}
                    className={`tab-pane fade ${currentTab === index ? 'show active' : ''}`}
                  >
                    {renderTabContent(title)}
                    <TitleList data={title} index={index} key={index} ref={el => title.ref = el} />
                  </div>
                ))}
              </div> */}
            </div>
            <StepperNavigationButtons index={props.index} steps={props.steps} navigate={props.navigate} save={Datapass1} />
          </div>
        </form>
      </div>
    )
  });


export default HomePage2;
